import { GlLink, GlSprintf } from '@gitlab/ui';
import { s__ } from '~/locale';
import DetailsRow from '~/vue_shared/components/registry/details_row.vue';
export default {
    name: 'MetadataNuget',
    i18n: {
        sourceText: s__('PackageRegistry|Source project located at %{link}'),
        licenseText: s__('PackageRegistry|License information located at %{link}')
    },
    components: {
        DetailsRow,
        GlLink,
        GlSprintf
    },
    props: {
        packageMetadata: {
            type: Object,
            required: true
        }
    }
};
